export default __webpack_public_path__ + "static/media/programs_usto_up.d7f35924.svg";